module.exports = __webpack_public_path__ + "media/src/components/InsuranceProduct/cancer-insurance-4656f4c553927ac61de7baf6750fe946.png";